import React from "react";
import theme from "../../theme";

const badge = {
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: "999px",
  fontSize: "11px",
  fontFamily: theme.fontFamily.MARKPROBOLD,
  marginRight: "6px",
  lineHeight: "16px",
};

// Role context badges for a member (is_super / is_admin / is_hr) + inactive flag.
function MemberBadges({ member }) {
  const badges = [];
  if (member?.is_super)
    badges.push({ key: "super", label: "Super", color: "#7C3AED", bg: "#EDE9FE" });
  if (member?.is_admin)
    badges.push({ key: "admin", label: "Admin", color: theme.colors.DodgerBlue, bg: theme.colors.Zumthor });
  if (member?.is_hr)
    badges.push({ key: "hr", label: "HR", color: theme.colors.ApproveGreen, bg: "#DCFCE7" });

  return (
    <span>
      {badges.map((b) => (
        <span key={b.key} style={{ ...badge, color: b.color, backgroundColor: b.bg }}>
          {b.label}
        </span>
      ))}
      {member && member.is_active === false ? (
        <span style={{ ...badge, color: theme.colors.RejectRed, backgroundColor: theme.colors.Cinderella }}>
          Inactive
        </span>
      ) : null}
    </span>
  );
}

export default MemberBadges;
